import { Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'toggle-button',
  template: `
    <input type="checkbox" id="toggle-button-checkbox" [(ngModel)]="model"
      (change)="changed.emit($event.target.checked)">
    <label class="toggle-button-switch"  
      for="toggle-button-checkbox"></label>
    <div class="toggle-button-text">
      <div *ngIf="model" class="toggle-button-text-on">Disponibil</div>
      <div *ngIf="!model" class="toggle-button-text-off">Ocupat</div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      position: relative;
      width: 100px;
      height: 50px;
    }
    
    input[type="checkbox"] {
      display: none; 
    }

    .toggle-button-switch {
      position: absolute;
      left: 10px;
      width: 35px;
      height: 35px;
      background-color: #fff;
      border-radius: 100%;
      cursor: pointer;
      z-index: 100;
      transition: left 0.3s;
    }

    .toggle-button-text {
      width: 150px;
      overflow: hidden;
      background-color: #fc3164;
      border-radius: 25px;
      box-shadow: 2px 2px 5px 0 rgba(50, 50, 50, 0.75);
      transition: background-color 0.3s;
    }

    .toggle-button-text-on,
    .toggle-button-text-off {
      float: left;
      width: 50%;
      height: 100%;
      line-height: 37px;
      font-family: Lato, sans-serif;
      font-weight: bold;
      color: #fff;
      text-align: center;
    }

    input[type="checkbox"]:checked ~ .toggle-button-switch {
      left: 105px;
    }

    input[type="checkbox"]:checked ~ .toggle-button-text {
      background-color: #3dbf87;
    }
  `]
})
export class ToggleButtonComponent  {
  @Input() model: boolean = false;
  @Output() changed = new EventEmitter<boolean>();
}
